export default "__VITE_ASSET__DcvCT2ia__"